import type { AirflowDagRunState, AirflowTaskInstanceState, DagListRunStatus } from '@/entities/dag/domain/types';

export const RUN_STATUS_LABEL_MAP: Record<AirflowDagRunState, string> = {
  failed: 'Failed',
  queued: 'Queued',
  running: 'Running',
  success: 'Success',
};

export const RUN_STATUS_COLOR_MAP: Record<AirflowDagRunState, 'error' | 'warning' | 'processing' | 'success'> = {
  failed: 'error',
  queued: 'warning',
  running: 'processing',
  success: 'success',
};

export const DAG_LIST_RUN_STATUS_LABEL_MAP: Record<DagListRunStatus, string> = {
  draft: 'Draft',
  failure: 'Failure',
  pending: 'Pending',
  running: 'Running',
  success: 'Success',
};

export const DAG_LIST_RUN_STATUS_COLOR_MAP: Record<
  DagListRunStatus,
  'default' | 'error' | 'warning' | 'processing' | 'success'
> = {
  draft: 'default',
  failure: 'error',
  pending: 'warning',
  running: 'processing',
  success: 'success',
};

export type DagTaskStatus = Exclude<AirflowTaskInstanceState, null> | 'none';

export const TASK_STATUS_LABEL_MAP: Record<DagTaskStatus, string> = {
  removed: '-',
  scheduled: 'Scheduled',
  queued: 'Queued',
  running: 'Running',
  success: 'Success',
  restarting: 'Restarting',
  failed: 'Failed',
  up_for_retry: 'Up for Retry',
  up_for_reschedule: 'Up for Reschedule',
  upstream_failed: 'Upstream Failed',
  skipped: 'Skipped',
  deferred: 'Deferred',
  none: '-',
};

export const TASK_STATUS_COLOR_MAP: Record<DagTaskStatus, 'default' | 'error' | 'warning' | 'processing' | 'success'> =
  {
    removed: 'default',
    scheduled: 'warning',
    queued: 'warning',
    running: 'processing',
    success: 'success',
    restarting: 'processing',
    failed: 'error',
    up_for_retry: 'warning',
    up_for_reschedule: 'warning',
    upstream_failed: 'error',
    skipped: 'default',
    deferred: 'processing',
    none: 'default',
  };
